var start_date = new Date(); // Current date in the local timezone
var expire_date_input = document.getElementById("ck_expire_date").value;

// Parse the input date in a consistent format (e.g., "MM/DD/YYYY")
var parts = expire_date_input.split('/');
var expire_date = new Date(parts[2], parts[0] - 1, parts[1]);

// To calculate the time difference of two dates
var Difference_In_Time = expire_date.getTime() - start_date.getTime();

// To calculate the no. of days between two dates
var Difference_In_Days =  Math.ceil(Difference_In_Time / (1000 * 3600 * 24));

// console.log(Difference_In_Days);
var codeCookieValue;
  var getCookie = function(name) {
    var value = "; " + document.cookie;
    var parts = value.split('; '+name+'=');
    if (parts.length == 2) return parts.pop().split(";").shift();
  };
  codeCookieValue = getCookie('discount_code');
  if(!codeCookieValue){
    console.log("No Discount Code");
  }
  if(codeCookieValue){
   // console.log("Discount Code - " + codeCookieValue);
   
  }

    function setCookie(name, value, days = Difference_In_Days) {
     
        let expires = "";
        let date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        // expires = "; expires=" + date.toUTCString();
        // document.cookie = name + "=" + (value || "")  + expires + "; path=/";
       Cookies.set(name, value, { expires: days })
      }
      
      function setDiscountCookie() {
        // console.log('test');
        let cookieval = getCookie('discount_code');
        let customcookieval = getCookie('discount_custom');
          // console.log(typeof cookieval);
        // console.log(customcookieval);
        if(cookieval!='undefined' && typeof cookieval !='undefined'){
          setCookie("discount_custom", cookieval, Difference_In_Days);
        }else{
          setCookie("discount_code", customcookieval, Difference_In_Days);
        }
      }
      setDiscountCookie();